import React from "react";
import { useNavigate } from "react-router-dom";

const AiPromoBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="
      w-full relative overflow-hidden rounded-none
      bg-gradient-to-r from-[#061A3A] via-[#0B3A7A] to-[#1D4ED8]
      px-6 py-10 sm:px-10 sm:py-12 md:px-14 md:py-14
    ">
      {/* 배경 장식 원 */}
      <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-white/5" />
      <div className="pointer-events-none absolute -bottom-20 right-32 h-48 w-48 rounded-full bg-blue-400/10" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-32 w-32 rounded-full bg-sky-300/10" />
      <div className="relative flex flex-col gap-6">

        {/* 텍스트 */}
        <div>
          <p className="text-[13px] sm:text-[15px] font-bold tracking-widest text-blue-200 uppercase mb-3">
            AI ASSISTANT · 24H AVAILABLE
          </p>
          <h2
            className="font-black leading-tight text-white"
            style={{ fontSize: "clamp(32px, 3.5vw, 56px)" }}
          >
            중대재해, 이제 AI에게 물어보세요
          </h2>
          <p className="mt-6 font-medium leading-relaxed text-blue-100" style={{ fontSize: "clamp(18px, 2vw, 26px)" }}>
            중대재해처벌법·안전 규정을 24시간 즉시 안내받을 수 있습니다.
          </p>
        </div>

        {/* 버튼 */}
        <button
          onClick={() => navigate("/ai")}
          className="
            group self-start flex items-center gap-2
            rounded-xl bg-teal-300 px-7 py-3.5
            shadow-md shadow-teal-300/25
            font-extrabold text-[20px] sm:text-[21px] text-slate-900
            transition-all duration-200
            hover:scale-105 hover:bg-teal-200 hover:shadow-lg hover:shadow-teal-300/40
            active:scale-100
          "
        >
          AI 알리미 시작하기
        </button>
      </div>
    </div>
  );
};

export default AiPromoBanner;
